<template>
    <div class="navbar-ui">
        <m-nav-toggle />
        <ul class="navigation mb-0" :class="{open:data.navbar.navActive === 'isNavbar'}">
            <!-- <m-nav-item  path="http://blog.madya.ir" :external="true" text="مقالات" /> -->
            <m-nav-item v-for="(item,index) in items"  :key="index" :external="item.external"  :path="item.path" :text="item.text" />
        </ul>
    </div>
</template>

<script>
import MNavItem from './navbar-item.vue'
import MNavToggle from './navbar-toggle.vue'
export default {
    name: 'navbar',
    components: {
        MNavItem,
        MNavToggle
    },
    props: {
        items: {
            type: Array,
            default: () => []
        },
    },
    inject: {
        methods: {
            default: {}
        },
        data: {
            default: {}
        },
    },
    data () {
        return {
        }
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style lang="less">
@import (reference) "../../../assets/css/variable.less";
.navigation {
  text-align: right;
}
@media screen and (max-width: 1200px) {
  .navigation li a {
    padding: 0px 15px;
  }
}
@media screen and (max-width: 992px) {
  .navigation.open {
    right: 0;
    z-index: 999;
  }
  .navigation {
    padding-top: 60px;
    text-align: center;
    background: #fff;
    position: fixed;
    right: -230px;
    top: 0;
    bottom: 0;
    transition: all 0.4s cubic-bezier(0, -0.22, 0.18, 1.06);
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    .box-clear;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/navbar/navbar.vue